import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rank-list-item-in-other is_full" }
const _hoisted_2 = { class: "rank-title-img bg-white" }
const _hoisted_3 = { class: "card-img-wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "rank-title-info bg-white" }
const _hoisted_6 = { class: "rank-title-desc" }
const _hoisted_7 = { class: "style-list" }
const _hoisted_8 = { class: "style-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: { path: '/rank/rank/'+_ctx.rank._id}
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.rank.primary_img,
              class: "card-img"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_RouterLink, {
        to: { path: '/rank/rank/'+_ctx.rank._id},
        class: "rank-title"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.rank.title), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.rank.desc), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_UserTag, {
          user: _ctx.rank.user_created,
          full: 1
        }, null, 8, ["user"]),
        _createTextVNode(" " + _toDisplayString(_ctx.formatTS(_ctx.rank.ts_updated)), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rank.styles, (style) => {
          return (_openBlock(), _createBlock(_component_StyleTag, {
            key: style._id,
            genre: style,
            full: 0
          }, null, 8, ["genre"]))
        }), 128))
      ])
    ])
  ]))
}